import { render, staticRenderFns } from "./day02.vue?vue&type=template&id=aa787048&scoped=true&"
var script = {}
import style0 from "./day02.vue?vue&type=style&index=0&id=aa787048&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa787048",
  null
  
)

export default component.exports